import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import assetPath from "~/utils/assetPath";
import LinkComponent from "~/components/LinkComponent";

// external-global styles must be imported in your JS.
import styles from "./styles.scss";

class FooterComponent extends React.Component {
  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="footer_component">
        <LinkComponent className="item about" to="/about" rel="nofollow">
          About
        </LinkComponent>
        <LinkComponent className="item contact" to="/contact" rel="nofollow">
          Contact
        </LinkComponent>
        <a className="item contact" href="#" id="pmLink">Privacy Manager</a>
        <div className="item social">
          <LinkComponent
            className="facebook"
            to="https://www.facebook.com/Jigsaw-Puzzle/"
            target="_blank"
            rel="nofollow"
          >
            <img
              className="lazyload"
              width="32"
              height="32"
              alt="Facebook icon"
              data-src={assetPath("facebook", "png")}
            />
          </LinkComponent>
          <LinkComponent
            className="twitter"
            to="https://twitter.com/jigsawpuzzle"
            target="_blank"
            rel="nofollow"
          >
            <img
              className="lazyload"
              width="32"
              height="32"
              alt="Twitter icon"
              data-src={assetPath("twitter", "png")}
            />
          </LinkComponent>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/FooterComponent/index.js